import { types } from 'actions/organisation';
import { purchasingSearch } from 'services/api';
import { noValue } from 'utils/search';
import { searchId as id } from 'components/common';
import { buildQuery as PurchasingBuildQuery } from 'utils/purchasing';
import { handleSearchError } from '../notifications';
import { defaultState } from './defaultState';

// Products Sold (purchasing) tab. Pure mechanical extraction — no behaviour
// change; unrelated to the shared People/Activity filter work.

export const purchasingReducers = {
  [types.SET_PURCHASING_SEARCH_REQUEST]: (state, action) => {
    if (action.payload.error) {
      handleSearchError(action.payload.error);
    }
    const { organisationId, searchRequest } = action.payload;
    if (searchRequest.res) {
      return {
        ...state,
        purchasingSearchRequest: {
          ...state.purchasingSearchRequest,
          [organisationId]: searchRequest.res,
        },
        purchasingLoading: false,
        blockedForPurchasingExport: false,
      };
    }
    if (searchRequest.loading) {
      return {
        ...state,
        purchasingLoading: searchRequest.loading,
      };
    }

    return {
      ...state,
      purchasingLoading: false,
    };
  },

  [types.PERFORM_PURCHASING_SEARCH]: (state, action) => {
    const { purchasingLastSuccessfulSearch } = state;
    const {
      useLastSuccessfulSearch,
      newSearch,
      organisationId,
    } = action.payload;
    const query = useLastSuccessfulSearch
      ? purchasingLastSuccessfulSearch.query
      : PurchasingBuildQuery(state.purchasingFilters);
    const cancelPurchasingSearch = action.payload.request({
      url: purchasingSearch,
      body: {
        id,
        query: query ?? '(*)',
        count: state.purchasingPageSize,
        from: newSearch
          ? 0
          : state.purchasingPageNumber * state.purchasingPageSize,
        order: state.purchasingSort,
        orderBy: state.purchasingSortDir,
        location: 'OrganisationPage',
        entityId: organisationId,
      },
    });

    return {
      ...state,
      purchasingLastSuccessfulSearch: { query, ...state.purchasingFilters },
      purchasingPageNumber: newSearch ? 0 : state.purchasingPageNumber,
      purchasingSearchRequest: {
        res: {},
        error: false,
      },
      purchasingLoading: true,
      cancelPurchasingSearch,
    };
  },
  // Export-history "search again": restores a saved purchasing filter set.
  [types.SET_ORG_PURCHASING_FILTERS_BY_STATE_GROUP]: (state, action) => {
    const { newState } = action.payload;
    return {
      ...state,
      purchasingFilters: newState,
      blockedForPurchasingExport: true,
    };
  },
  [types.SET_PURCHASING_FILTER]: (state, action) => {
    const filters = { ...state.purchasingFilters };
    const { id, value } = action.payload;
    if (noValue(value)) {
      delete filters[id];
    } else {
      filters[id] = value;
    }
    return {
      ...state,
      purchasingFilters: filters,
      blockedForPurchasingExport: true,
    };
  },
  [types.SET_PURCHASING_FILTER_GROUP]: (state, action) => {
    let filters = { ...state.purchasingFilters };
    const { group, id, value } = action.payload;
    if (noValue(value)) {
      delete filters[group][id];
    } else {
      filters = {
        ...filters,
        [group]: {
          ...filters[group],
          [id]: value,
        },
      };
    }
    if (Object.keys(filters[group]).length === 0) {
      delete filters[group];
    }
    return {
      ...state,
      purchasingFilters: filters,
      blockedForPurchasingExport: true,
    };
  },
  [types.SET_PURCHASING_SORT]: (state, action) => {
    let sort;
    let sortDir;

    if (action.payload.sort === state.purchasingSort) {
      if (state.purchasingSortDir === 'asc') {
        sort = action.payload.sort;
        sortDir = 'desc';
      } else {
        sort = '';
        sortDir = '';
      }
    } else {
      sort = action.payload.sort;
      sortDir = 'asc';
    }

    return {
      ...state,
      purchasingSort: sort,
      purchasingSortDir: sortDir,
    };
  },
  [types.SET_PURCHASING_PAGE_SIZE]: (state, action) => ({
    ...state,
    purchasingPageSize: action.payload.size,
  }),
  [types.SET_PURCHASING_PAGE_NUMBER]: (state, action) => ({
    ...state,
    purchasingPageNumber: action.payload.number,
  }),
  [types.CLEAR_PURCHASING_FILTERS]: state => ({
    ...state,
    purchasingFilters: {
      ...defaultState.purchasingFilters,
    },
    blockedForPurchasingExport: true,
  }),
};
